import { Heart } from "lucide-react";

import { SkeletonLoader } from "../../../common/SkeletonLoader";

import { JobCard } from "./JobCard";

export function Saved({ jobs, isLoading, onJobUpdated }) {
  const savedJobs = jobs.filter((job) => job.isSaved);

  if (isLoading) {
    return (
      <main className="flex flex-col gap-y-4">
        {Array.from({ length: 3 }).map((_, idx) => (
          <SkeletonLoader key={idx} />
        ))}
      </main>
    );
  }

  if (savedJobs.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[250px]">
        <div className="flex flex-col gap-y-4 items-center justify-center text-gray-400 dark:text-gray-500">
          <Heart className="size-10" />
          <h2 className="text-md font-medium">
            You haven&apos;t saved any jobs yet.
          </h2>
        </div>
      </div>
    );
  }

  return (
    <main className="flex flex-col gap-y-4">
      {savedJobs.map((job) => (
        <JobCard key={job.id} job={job} onJobUpdated={onJobUpdated} />
      ))}
    </main>
  );
}
